import Message from 'types/Message';
import AdvantagesSection from '@components/molecules/AdvantagesSection';
import Typography from '@components/atoms/Typography';

import classes from './WhyTrustUs.module.scss';

export type Item = {
  id: number;
  title: Message;
  subtitle: Message;
};

export type Props = {
  title: Message;
  subtitle: Message;
  className?: string;
  items: Item[];
};

const WhyTrustUs = ({ title, subtitle, className, items }: Props): JSX.Element => (
  <AdvantagesSection title={title} subtitle={subtitle} className={className} advantagesClassName={classes.advantages}>
    {items.map(({ id, title: itemTitle, subtitle: itemSubtitle }) => (
      <div key={id} className={classes.item}>
        <div className={classes.title}>{itemTitle}</div>
        <Typography variant="body1" align="center">
          {itemSubtitle}
        </Typography>
      </div>
    ))}
  </AdvantagesSection>
);

export default WhyTrustUs;
